import { render, staticRenderFns } from "./circleNote.vue?vue&type=template&id=3e5113f9&scoped=true&"
import script from "./circleNote.vue?vue&type=script&lang=js&"
export * from "./circleNote.vue?vue&type=script&lang=js&"
import style0 from "./circleNote.vue?vue&type=style&index=0&id=3e5113f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5113f9",
  null
  
)

export default component.exports